(function() {
    'use strict';

    angular.module('app').filter('monthName', monthName);

    var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    function monthName() {
        return function (monthNumber) {
            return monthNames[monthNumber];
        }
    }
})();